<ng-select [items]="reportTypes" autofocus bindLabel="reportTypeName" bindValue="reportTypeId"
    [virtualScroll]="true" placeholder="Please Select" [(ngModel)]="reportTypeId"
    (ngModelChange)="reportTypeChanged()" [selectOnTab]="true">
</ng-select>
